import React from 'react';
import {doc3} from '../../constants'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-12">
            <div><a href={doc3} target="_blank">Политика компании по защите персональных данных</a></div>
            <div className="copyright">&copy; Глобо-Центр</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
